import api from './api'
import {
  AuthMeResponse,
  LoginCredentials,
  AuthResponse,
  UserType,
} from '@/types/UserType'

export async function login(
  credentials: LoginCredentials,
): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>(
    '/api/platform/auth/login',
    credentials,
    { skipGlobalErrorToast: true },
  )
  return response.data
}

export async function logout(): Promise<void> {
  await api.post('/api/platform/auth/logout')
}

export async function me(): Promise<UserType> {
  const response = await api.get<AuthMeResponse>('/api/platform/auth/me')
  return response.data.admin
}
